module.exports = __webpack_public_path__ + "static/gradientOne-24265a85c13b798743d20bf8ea4b1465.png";